module.exports = __webpack_public_path__ + "img/tg.025deae8.svg";